import { z } from 'zod';

export const addContactSchema = z.object({
    name: z.string().min(1, 'Name is required'),
    email: z.string().min(1, 'Email is required').email('Please enter a valid email address'),
    phoneNumber: z.string().optional(),
});

export type AddContactFormData = z.infer<typeof addContactSchema>;
